import { render, staticRenderFns } from "./Questionaireliste.vue?vue&type=template&id=52168a27&"
import script from "./Questionaireliste.vue?vue&type=script&lang=js&"
export * from "./Questionaireliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports